export default "__VITE_ASSET__BiIU05fh__"